
import React from 'react';
import { User } from 'lucide-react';
import Container from '@/components/ui/Container';
import DashboardHeader from '@/components/dashboard/DashboardHeader';

interface ProfileLayoutProps {
  children: React.ReactNode;
}

const ProfileLayout = ({ children }: ProfileLayoutProps) => {
  return (
    <Container>
      <DashboardHeader 
        title="Account"
        description="Manage your account details and preferences."
        icon={<User size={24} />}
        hideOnMobile={false}
      />
      
      {children}
    </Container>
  );
};

export default ProfileLayout;
